export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";